<template>
  <div>
    <navBody class="navContainer"></navBody>
    <div class="mainContainer">
      <transition name="fade" mode="out-in">
        <router-view v-cloak />
      </transition>
    </div>
    <footBody class="footContainer"></footBody>
    <transition name="fade" mode="out-in">
      <loginTooltip v-show="$store.state.show"></loginTooltip>
    </transition>
  </div>
</template>

<script>
  import navBody from './components/navBody';
  import footBody from './components/footBody';
  import loginTooltip from './components/loginTooltip';
  export default {
    data() {
      return {
      }
    },
    components: {
      navBody,
      footBody,
      loginTooltip
    },
    methods: {
      
    }
  }

</script>

<style scoped>
  .navContainer {
    box-shadow: 0 2px 8px 1px #eeeeee;
  }

  .mainContainer {
    margin-bottom: 41px;
  }

  .footContainer {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    z-index: 9999;
  }

</style>



// WEBPACK FOOTER //
// src/views/temp/index.vue